// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1e7lK","requiredAsterisk":"Info_requiredAsterisk__A4xvf"};